window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.BackDisabled = function() {
	this.initialize(img.MainAssets_RTL_BackDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BackDown = function() {
	this.initialize(img.MainAssets_RTL_BackDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_RTL_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.BackgroundLevel01s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel01s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel02s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel02s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel03s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel03s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel04s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel04s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel05s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel05s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel06s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel06s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel07s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel07s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel08s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel08s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel09s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel09s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel10s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel10s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel11s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel11s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel12s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel12s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel13s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel13s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackgroundLevel14s = function() {
	this.initialize(img.MainAssets_RTL_BackgroundLevel14s);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1333,2108);


(lib.BackUp = function() {
	this.initialize(img.MainAssets_RTL_BackUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,42);


(lib.BigPanelBG = function() {
	this.initialize(img.MainAssets_RTL_BigPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1080,1743);


(lib.BirdSpotterBalloon = function() {
	this.initialize(img.MainAssets_RTL_BirdSpotterBalloon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,741,204);


(lib.BottomFloatingPanelBG = function() {
	this.initialize(img.MainAssets_RTL_BottomFloatingPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1046,214);


(lib.Buoy = function() {
	this.initialize(img.MainAssets_RTL_Buoy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,190,298);


(lib.EndscreenBGPanel = function() {
	this.initialize(img.MainAssets_RTL_EndscreenBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,609);


(lib.EndscreenBGPanelLonger = function() {
	this.initialize(img.MainAssets_RTL_EndscreenBGPanelLonger);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,709);


(lib.FeedbackPanelBg = function() {
	this.initialize(img.MainAssets_RTL_FeedbackPanelBg);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,225,75);


(lib.Fish01_1 = function() {
	this.initialize(img.MainAssets_RTL_Fish01_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_2 = function() {
	this.initialize(img.MainAssets_RTL_Fish01_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_3 = function() {
	this.initialize(img.MainAssets_RTL_Fish01_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_4 = function() {
	this.initialize(img.MainAssets_RTL_Fish01_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_5 = function() {
	this.initialize(img.MainAssets_RTL_Fish01_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_6 = function() {
	this.initialize(img.MainAssets_RTL_Fish01_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish01_7 = function() {
	this.initialize(img.MainAssets_RTL_Fish01_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_1 = function() {
	this.initialize(img.MainAssets_RTL_Fish02_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_2 = function() {
	this.initialize(img.MainAssets_RTL_Fish02_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_3 = function() {
	this.initialize(img.MainAssets_RTL_Fish02_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_4 = function() {
	this.initialize(img.MainAssets_RTL_Fish02_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_5 = function() {
	this.initialize(img.MainAssets_RTL_Fish02_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_6 = function() {
	this.initialize(img.MainAssets_RTL_Fish02_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish02_7 = function() {
	this.initialize(img.MainAssets_RTL_Fish02_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_1 = function() {
	this.initialize(img.MainAssets_RTL_Fish03_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_2 = function() {
	this.initialize(img.MainAssets_RTL_Fish03_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_3 = function() {
	this.initialize(img.MainAssets_RTL_Fish03_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_4 = function() {
	this.initialize(img.MainAssets_RTL_Fish03_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_5 = function() {
	this.initialize(img.MainAssets_RTL_Fish03_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_6 = function() {
	this.initialize(img.MainAssets_RTL_Fish03_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish03_7 = function() {
	this.initialize(img.MainAssets_RTL_Fish03_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_1 = function() {
	this.initialize(img.MainAssets_RTL_Fish04_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_2 = function() {
	this.initialize(img.MainAssets_RTL_Fish04_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_3 = function() {
	this.initialize(img.MainAssets_RTL_Fish04_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_4 = function() {
	this.initialize(img.MainAssets_RTL_Fish04_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_5 = function() {
	this.initialize(img.MainAssets_RTL_Fish04_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_6 = function() {
	this.initialize(img.MainAssets_RTL_Fish04_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish04_7 = function() {
	this.initialize(img.MainAssets_RTL_Fish04_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_1 = function() {
	this.initialize(img.MainAssets_RTL_Fish05_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_2 = function() {
	this.initialize(img.MainAssets_RTL_Fish05_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_3 = function() {
	this.initialize(img.MainAssets_RTL_Fish05_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_4 = function() {
	this.initialize(img.MainAssets_RTL_Fish05_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_5 = function() {
	this.initialize(img.MainAssets_RTL_Fish05_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_6 = function() {
	this.initialize(img.MainAssets_RTL_Fish05_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish05_7 = function() {
	this.initialize(img.MainAssets_RTL_Fish05_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_1 = function() {
	this.initialize(img.MainAssets_RTL_Fish06_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_2 = function() {
	this.initialize(img.MainAssets_RTL_Fish06_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_3 = function() {
	this.initialize(img.MainAssets_RTL_Fish06_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_4 = function() {
	this.initialize(img.MainAssets_RTL_Fish06_4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_5 = function() {
	this.initialize(img.MainAssets_RTL_Fish06_5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_6 = function() {
	this.initialize(img.MainAssets_RTL_Fish06_6);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fish06_7 = function() {
	this.initialize(img.MainAssets_RTL_Fish06_7);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,451,451);


(lib.Fishingtut1 = function() {
	this.initialize(img.MainAssets_RTL_Fishingtut1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,822,712);


(lib.Fishingtut2 = function() {
	this.initialize(img.MainAssets_RTL_Fishingtut2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,822,532);


(lib.fishingtut4 = function() {
	this.initialize(img.MainAssets_RTL_fishingtut4);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,862,453);


(lib.Fishingtut5 = function() {
	this.initialize(img.MainAssets_RTL_Fishingtut5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,862,558);


(lib.Fishingspot_1 = function() {
	this.initialize(img.MainAssets_RTL_Fishingspot_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,383,196);


(lib.FishingSpotBubble = function() {
	this.initialize(img.MainAssets_RTL_FishingSpotBubble);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,43,22);


(lib.FishingSpotDarker = function() {
	this.initialize(img.MainAssets_RTL_FishingSpotDarker);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotHighlight = function() {
	this.initialize(img.MainAssets_RTL_FishingSpotHighlight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingspotPart01 = function() {
	this.initialize(img.MainAssets_RTL_FishingspotPart01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotPart02 = function() {
	this.initialize(img.MainAssets_RTL_FishingSpotPart02);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotPart03 = function() {
	this.initialize(img.MainAssets_RTL_FishingSpotPart03);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FishingSpotPart04 = function() {
	this.initialize(img.MainAssets_RTL_FishingSpotPart04);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,420,420);


(lib.FloatingPracticePanelBG = function() {
	this.initialize(img.MainAssets_RTL_FloatingPracticePanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,982,119);


(lib.MainButtonDis = function() {
	this.initialize(img.MainAssets_RTL_MainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonDown = function() {
	this.initialize(img.MainAssets_RTL_MainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonHi = function() {
	this.initialize(img.MainAssets_RTL_MainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonUp = function() {
	this.initialize(img.MainAssets_RTL_MainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.ProfCorrect = function() {
	this.initialize(img.MainAssets_RTL_ProfCorrect);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1071,1344);


(lib.ProfessorRod = function() {
	this.initialize(img.MainAssets_RTL_ProfessorRod);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2277,2084);


(lib.ProfIncorrect = function() {
	this.initialize(img.MainAssets_RTL_ProfIncorrect);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1420,1344);


(lib.ProfNeutral_Closed = function() {
	this.initialize(img.MainAssets_RTL_ProfNeutral_Closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1071,1344);


(lib.Splashscreen = function() {
	this.initialize(img.MainAssets_RTL_Splashscreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,2667,6188);


(lib.SpotterTimerBG = function() {
	this.initialize(img.MainAssets_RTL_SpotterTimerBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,143,143);


(lib.SpotterTimerOutline = function() {
	this.initialize(img.MainAssets_RTL_SpotterTimerOutline);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,143,143);


(lib.UndoIcon = function() {
	this.initialize(img.MainAssets_RTL_UndoIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,57,66);


(lib.UndoIconDisabled = function() {
	this.initialize(img.MainAssets_RTL_UndoIconDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,57,66);


(lib.UndoIconHi = function() {
	this.initialize(img.MainAssets_RTL_UndoIconHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,57,66);


(lib.WhiteArrow = function() {
	this.initialize(img.MainAssets_RTL_WhiteArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,73,61);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.UndoButtonIconHi = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.UndoIconHi();
	this.instance.setTransform(-28.5,-33);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.UndoButtonIconHi, new cjs.Rectangle(-28.5,-33,57,66), null);


(lib.UndoButtonIconDis = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.UndoIconDisabled();
	this.instance.setTransform(-28.5,-33);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.UndoButtonIconDis, new cjs.Rectangle(-28.5,-33,57,66), null);


(lib.UndoButtonIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.UndoIcon();
	this.instance.setTransform(-28.5,-33);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.UndoButtonIcon, new cjs.Rectangle(-28.5,-33,57,66), null);


(lib.TextBalloon2Slice9Panel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// shortRuleLabelTextField
	this.shortRuleLabelTextField = new cjs.Text("Observing...Observing.\nObserving...Observing.\nObserving...Observing.", "36px 'Poppins'", "#0F5184");
	this.shortRuleLabelTextField.name = "shortRuleLabelTextField";
	this.shortRuleLabelTextField.textAlign = "right";
	this.shortRuleLabelTextField.lineHeight = 47;
	this.shortRuleLabelTextField.lineWidth = 435;
	this.shortRuleLabelTextField.parent = this;
	this.shortRuleLabelTextField.setTransform(123,-78);
ranj.TextOffsetFixer.fix(this.shortRuleLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.shortRuleLabelTextField).wait(1));

	// ruleLabelTextField
	this.ruleLabelTextField = new cjs.Text("Observing...Observing...Observing..\nObserving...Observing...Observing..\nObserving...Observing...Observing..", "36px 'Poppins'", "#0F5184");
	this.ruleLabelTextField.name = "ruleLabelTextField";
	this.ruleLabelTextField.textAlign = "right";
	this.ruleLabelTextField.lineHeight = 47;
	this.ruleLabelTextField.lineWidth = 626;
	this.ruleLabelTextField.parent = this;
	this.ruleLabelTextField.setTransform(313.95,-78);
ranj.TextOffsetFixer.fix(this.ruleLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.ruleLabelTextField).wait(1));

	// Textballoon_Small.png
	this.instance = new lib.BirdSpotterBalloon();
	this.instance.setTransform(-398,-100);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TextBalloon2Slice9Panel, new cjs.Rectangle(-398,-100,741,204), null);


(lib.SelectionPulse = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotHighlight();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SelectionPulse, new cjs.Rectangle(-105,-105,210,210), null);


(lib.Professor01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {neutral:0,open:1,correct:2,incorrect:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// images
	this.instance = new lib.ProfNeutral_Closed();
	this.instance.setTransform(-94.45,-321.35,0.2492,0.2493);

	this.instance_1 = new lib.ProfCorrect();
	this.instance_1.setTransform(-94.45,-321.35,0.2492,0.2493);

	this.instance_2 = new lib.ProfIncorrect();
	this.instance_2.setTransform(-178.45,-321.35,0.2492,0.2493);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-178.4,-321.3,353.9,335);


(lib.Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(47,47,47,0)").ss(4,2,1).p("EhmrikcMDNXAAAQCjAAAACbMAAAFECQAACcijAAMjNXAAAQijAAAAicMAAAlECQAAibCjAAg");
	this.shape.setTransform(673.475,1052.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0E95FD").s().p("EhmrCkdQijAAAAicMAAAlEBQAAicCjAAMDNXAAAQCjAAAACcMAAAFEBQAACcijAAg");
	this.shape_1.setTransform(673.475,1052.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Overlay, new cjs.Rectangle(-2,-2,1351,2109), null);


(lib.hitArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApPDQQhWAAg9g+Qg9g8AAhWQAAhVA9g9QA9g9BWABISfAAQBWgBA9A9QA9A9AABVQAABWg9A8Qg9A+hWAAg");
	this.shape.setTransform(79.9796,20.75,1.0003,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.hitArea, new cjs.Rectangle(0,0,160,41.5), null);


(lib.GatekeeperBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.BigPanelBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GatekeeperBackground, new cjs.Rectangle(0,0,1080,1743), null);


(lib.Floaty = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.numberTextfield = new cjs.Text("1", "bold 39px 'Poppins ExtraBold'", "#FFFFFF");
	this.numberTextfield.name = "numberTextfield";
	this.numberTextfield.textAlign = "center";
	this.numberTextfield.lineHeight = 79;
	this.numberTextfield.lineWidth = 23;
	this.numberTextfield.parent = this;
	this.numberTextfield.setTransform(-0.2,-29.952);
ranj.TextOffsetFixer.fix(this.numberTextfield);

	this.instance = new lib.Buoy();
	this.instance.setTransform(-49.35,-104.45,0.5263,0.5264);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.numberTextfield}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Floaty, new cjs.Rectangle(-49.3,-104.4,100,156.8), null);


(lib.FishingSpot_pt4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotPart04();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt4, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_pt3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotPart03();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt3, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_pt2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotPart02();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt2, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_pt1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingspotPart01();
	this.instance.setTransform(-105,-105,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_pt1, new cjs.Rectangle(-105,-105,210,210), null);


(lib.FishingSpot_Bubble = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotBubble();
	this.instance.setTransform(-10.75,-5.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishingSpot_Bubble, new cjs.Rectangle(-10.7,-5.5,21.5,11), null);


(lib.Fish7F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish7A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_7();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish7A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish6A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_6();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish6A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish5A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_5();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish5A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// white
	this.instance = new lib.Fish04_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish4A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_4();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish4A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish3A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_3();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish3A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish2A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_2();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish2A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1F = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish06_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1F, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1E = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish05_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1E, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1D = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish04_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1D, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1C = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish03_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1C, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1B = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish02_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1B, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.Fish1A = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Fish01_1();
	this.instance.setTransform(-113,-226,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Fish1A, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.EmptyHudBottom = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1500,178.8);


(lib.DarkPulse = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FishingSpotDarker();
	this.instance.setTransform(-105,-112,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DarkPulse, new cjs.Rectangle(-105,-112,210,210), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1286,1334.1,2802), null);


(lib.LevelPrepareOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// instructionLabel
	this.instructionLabel = new cjs.Text("xObserve the fish!", "bold 120px 'Poppins ExtraBold'", "#FFFFFF");
	this.instructionLabel.name = "instructionLabel";
	this.instructionLabel.textAlign = "center";
	this.instructionLabel.lineHeight = 131;
	this.instructionLabel.lineWidth = 1149;
	this.instructionLabel.parent = this;
	this.instructionLabel.setTransform(0,-207.75);
ranj.TextOffsetFixer.fix(this.instructionLabel);

	this.timeline.addTween(cjs.Tween.get(this.instructionLabel).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(15,151,255,0.498)").s().p("EhoSDBcMAAAmC3MDQlAAAMAAAGC3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelPrepareOverlaySkin, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.TutorialLines5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-450,-360.2,742.4,189);


(lib.TutorialLines4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-448.7,-173.8,911.4,1408.8999999999999);


(lib.TutorialLines3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.TutorialLines2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-436,-618.4,872,699.5);


(lib.TutorialLines1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-450.6,-641.7,750.7,646.7);


(lib.TutorialGameBackground4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.numberTextfield = new cjs.Text("1", "bold 40px 'Poppins ExtraBold'", "#FFFFFF");
	this.numberTextfield.name = "numberTextfield";
	this.numberTextfield.lineHeight = 81;
	this.numberTextfield.lineWidth = 23;
	this.numberTextfield.parent = this;
	this.numberTextfield.setTransform(296.8,97.398);
ranj.TextOffsetFixer.fix(this.numberTextfield);

	this.instance = new lib.Buoy();
	this.instance.setTransform(258.9,22.9,0.5263,0.5264);

	this.instance_1 = new lib.Fishingspot_1();
	this.instance_1.setTransform(81.35,144.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance},{t:this.numberTextfield}]}).wait(1));

	// Layer_2
	this.instance_2 = new lib.fishingtut4();
	this.instance_2.setTransform(-431,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground4, new cjs.Rectangle(-667.5,-1238,1335.4,2476), null);


(lib.TutorialGameBackground2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-667.5,-1238,1335.4,2476);


(lib.TutorialGameBackground1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.instance = new lib.Fish03_3();
	this.instance.setTransform(83.5,66.55,0.5,0.5);

	this.instance_1 = new lib.Fishingspot_1();
	this.instance_1.setTransform(99.35,244,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// bg
	this.instance_2 = new lib.Fishingtut1();
	this.instance_2.setTransform(-411,-99.15);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground1, new cjs.Rectangle(-667.4,-1158,1335.3,2307.5), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.TutorialBackgroundPractice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-781,-1310,1562,2797.3);


(lib.TutorialBackgroundNext = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-667.5,-1259.7,1335,2497.7);


(lib.TutorialBackgroundBird = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-683.1,-1238,1364.5,2497.1);


(lib.TutorialBackground2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Fish
	this.instance = new lib.Fish06_1();
	this.instance.setTransform(134.05,246.65,0.6098,0.6093);

	this.instance_1 = new lib.Fish05_1();
	this.instance_1.setTransform(-140.55,246.65,0.6098,0.6093);

	this.instance_2 = new lib.Fish04_1();
	this.instance_2.setTransform(-416.45,246.65,0.6098,0.6093);

	this.instance_3 = new lib.Fish03_1();
	this.instance_3.setTransform(134.05,0,0.6098,0.6093);

	this.instance_4 = new lib.Fish02_1();
	this.instance_4.setTransform(-140.55,0,0.6098,0.6093);

	this.instance_5 = new lib.Fish01_1();
	this.instance_5.setTransform(-416.5,0,0.6098,0.6094);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackground2, new cjs.Rectangle(-748.2,-1238,1451.9,2476), null);


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#DDE5F0").s().p("Ag/BAQgagbAAglQAAgkAagbQAbgaAkAAQAkAAAbAaQAbAbAAAkQAAAlgbAbQgbAagkAAQgkAAgbgag");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-9,-9,18,18);


(lib.PracticeIndicatorSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.textfield = new cjs.Text("xPractice level", "bold 51px 'Poppins'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 90;
	this.textfield.lineWidth = 895;
	this.textfield.parent = this;
	this.textfield.setTransform(-0.05,-42.05);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg BITMAPS
	this.instance = new lib.FloatingPracticePanelBG();
	this.instance.setTransform(-491,-59.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PracticeIndicatorSkin, new cjs.Rectangle(-491,-59.5,982,119), null);


(lib.GateKeeperOverlayLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.Dot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AhFBGQgegdAAgpQAAgoAegdQAcgeApAAQApAAAeAeQAdAdAAAoQAAApgdAdQgeAegpAAQgpAAgcgeg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.LevelPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("[level]", "bold 120px 'Poppins ExtraBold'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 131;
	this.text.lineWidth = 610;
	this.text.alpha = 0.80000000;
	this.text.parent = this;
	this.text.setTransform(-21.45,-104.8);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelPlaceholder, new cjs.Rectangle(-328.5,-106.8,614.2,268.3), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "39px 'Poppins SemiBold'", "#0F97FF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 70;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(0.0002,-35.25);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.instance = new lib.FeedbackPanelBg();
	this.instance.setTransform(-113,-38);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113,-38,225,75.3), null);


(lib.SubmitButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Down
	this.downLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 341;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.5,-35);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 341;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.5,-35);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 341;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.5,-35);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 341;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.5,-35);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.MainButtonUp();
	this.instance.setTransform(-210,-63);

	this.instance_1 = new lib.MainButtonHi();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.MainButtonDown();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.MainButtonDis();
	this.instance_3.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,419,126);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(-98,31,1,1,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(26.05,-36);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(26.05,-36);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(26.05,-36);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(26.05,-36);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.MainButtonUp();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.MainButtonHi();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.MainButtonDown();
	this.instance_3.setTransform(-210,-63);

	this.instance_4 = new lib.MainButtonDis();
	this.instance_4.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,419,129);


(lib.Backgroundwhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhoICksMAAAlJXMDQRAAAMAAAFJXg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Backgroundwhite, new cjs.Rectangle(-666.5,-1054,1333,2108), null);


(lib.TimerFillIntroduction = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CC421A").s().p("AlXLAIgIAAIAA1/IAIAAIABAAQEeADDKDMQDODOAAEiQAAEkjODOQjKDKkeAEg");
	this.shape.setTransform(47.5269,0.0188,1.35,1.35);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_3 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("AlHLKQmPhqjPlmQAAgBBIgsIZRumQApgWABACQDPFmhtGOQhsGPlmDPQjtCJj+AAQiDAAiHgkg");
	mask.setTransform(6.9879,25.2833);

	// Layer_2
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CC421A").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_1.setTransform(0.0061,0.0188,1.35,1.35);

	var maskedShapeInstanceList = [this.shape_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer_5
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_2.setTransform(0.0387,0.0573,1.4047,1.4047);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimerFillIntroduction, new cjs.Rectangle(-98.8,-98.8,197.7,197.7), null);


(lib.TimerFill = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("AlXLAIgIAAIAA1/IAIAAIABAAQEeADDKDMQDODOAAEiQAAEkjODOQjKDKkeAEg");
	this.shape.setTransform(0,-0.1,0.9282,0.9282,0,0,0,-35.3,-0.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#0F97FF").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_1.setTransform(0.0249,0.0533,0.9416,0.9415);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},49).to({state:[{t:this.shape_1}]},51).wait(1));

	// Layer_3 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AiLHWQjFjDAAkTQAAkTDFjDQDDjCEWAAIACA4IABTaQgBAfgCAAQkXAAjCjDg");
	var mask_graphics_1 = new cjs.Graphics().p("AEPKZQkUgSi3jPQi4jPASkTQASkSDQi2QDPi2EVASIgBA4IhPTYQgDAfgCAAIAAAAg");
	var mask_graphics_2 = new cjs.Graphics().p("ADQKXQkTgkipjaQiqjbAjkQQAjkRDcioQDaioEUAjIgFA5IieTQQgGAegBAAIAAAAg");
	var mask_graphics_3 = new cjs.Graphics().p("ACRKUQkQg1ibjlQibjlA0kOQA1kODmiaQDkiZERA1IgJA4IjtTDQgHAegBAAIAAAAg");
	var mask_graphics_4 = new cjs.Graphics().p("ABSKPQkMhGiLjvQiNjuBGkJQBGkLDviKQDuiLENBGIgMA4Ik7SxQgJAdgCAAIAAAAg");
	var mask_graphics_5 = new cjs.Graphics().p("AAVKJQkHhXh8j3Qh8j3BWkEQBXkFD4h7QD2h8EHBYIgQA2ImGSbQgLAcgCAAIAAAAg");
	var mask_graphics_6 = new cjs.Graphics().p("AgmKCQkChohsj+Qhsj+Bnj/QBoj/D+hrQD+hrEBBoIgTA1InRR/QgMAcgCAAIAAAAg");
	var mask_graphics_7 = new cjs.Graphics().p("AhhJ5Qj6h4hbkFQhckDB3j4QB4j4EFhbQEEhaD5B4IgWA0IoaRfQgOAbgCAAIAAgBg");
	var mask_graphics_8 = new cjs.Graphics().p("AiaJwQjyiJhKkKQhLkICHjwQCHjwEKhKQEJhJDyCIIgaAyIpgQ6QgQAagCAAIAAAAg");
	var mask_graphics_9 = new cjs.Graphics().p("AjRJkQjoiXg6kOQg5kNCWjnQCWjnENg4QEOg4DpCXIgdAwIqkQRQgSAYgCAAIAAAAg");
	var mask_graphics_10 = new cjs.Graphics().p("AkGJYQjeimgokRQgokQCljdQCkjcEQgnQESgnDeClIggAvIrmPjQgSAXgCAAIgBAAg");
	var mask_graphics_11 = new cjs.Graphics().p("Ak4JKQjTizgWkTQgXkSCzjSQCyjSESgVQETgWDTC0IgjAsIskOyQgUAVgCAAIAAAAg");
	var mask_graphics_12 = new cjs.Graphics().p("AloI8QjHjBgEkUQgFkTC/jGQDAjFETgEQETgEDHDBIglAqItfN8QgVAUgCAAIgBAAg");
	var mask_graphics_13 = new cjs.Graphics().p("AmUItQi6jOANkTQANkTDLi5QDMi5ETAOQETAOC6DNIgoAnIuWNDQgWATgDAAIAAAAg");
	var mask_graphics_14 = new cjs.Graphics().p("Am9IdQitjZAfkSQAekRDXisQDXirERAfQESAgCtDYIgrAlIvJMGQgYARgCAAIAAAAg");
	var mask_graphics_15 = new cjs.Graphics().p("AnjIMQifjjAxkQQAvkODiieQDiidEOAxQEPAxCfDiIgtAiIv5LGQgYAQgDAAIAAAAg");
	var mask_graphics_16 = new cjs.Graphics().p("AoGH6QiPjtBBkLQBBkLDsiPQDriOELBCQELBCCPDsIgvAfIwkKEQgZANgDAAIAAAAg");
	var mask_graphics_17 = new cjs.Graphics().p("AolHoQiAj2BTkGQBSkHD0h/QD0h/EFBTQEHBTCAD1IgxAcIxLI+QgZAMgEAAIAAAAg");
	var mask_graphics_18 = new cjs.Graphics().p("ApBHUQhwj8BkkAQBjkCD7hvQD7hvEABjQEBBkBwD9IgzAYIxtH3QgaAKgDAAIgBgBg");
	var mask_graphics_19 = new cjs.Graphics().p("ApZHBQhfkEBzj5QB0j6EChfQEBhfD6B0QD6B0BfEDIg0AUIyMGuQgZAIgEAAIgBAAg");
	var mask_graphics_20 = new cjs.Graphics().p("AptGsQhPkJCEjxQCDjyEIhOQEGhPDyCEQDyCEBOEHIg1ASIykFiQgZAHgFAAIgBgBg");
	var mask_graphics_21 = new cjs.Graphics().p("Ap9GXQg+kNCTjoQCSjpEMg+QELg9DpCTQDpCTA+EMIg3AOIy4EVQgYAFgGAAIgBgBg");
	var mask_graphics_22 = new cjs.Graphics().p("AqKGCQgskRChjeQChjfEQgsQEOgsDfChQDfCiAsEPIg3ALIzIDHIgcACIgDAAg");
	var mask_graphics_23 = new cjs.Graphics().p("AqSFsQgbkTCwjTQCujUESgbQERgaDUCvQDUCvAbESIg4AHIzSB4IgYABQgHAAAAgBg");
	var mask_graphics_24 = new cjs.Graphics().p("AqWFWQgJkUC8jHQC8jJETgJQESgJDIC9QDJC7AJEUIg5AEIzWAoQgfAAAAgCg");
	var mask_graphics_25 = new cjs.Graphics().p("AJfFXIzXgnQgfgCAAgCQAJkTDJi7QDJi9ESAJQESAJC8DJQC8DHgJEUIgVAAIgjAAg");
	var mask_graphics_26 = new cjs.Graphics().p("AJbFpIzSh2QgfgEABgCQAakSDViuQDUivEQAaQESAaCvDVQCuDTgaESIgBAAIg3gDg");
	var mask_graphics_27 = new cjs.Graphics().p("AJTF7IzIjFQgegHAAgBQAskQDfigQDfihEPAsQEPAsChDfQCgDegsEQIAAAAIg3gHg");
	var mask_graphics_28 = new cjs.Graphics().p("AJHGMIy4kTQgegIAAgCQA9kMDpiRQDpiTELA9QEMA+CSDoQCSDog9ENIAAAAIg3gLg");
	var mask_graphics_29 = new cjs.Graphics().p("AI3GdIyklgQgdgKAAgBQBPkIDxiCQDyiDEHBOQEHBOCDDyQCDDwhOEIIgBAAIg2gOg");
	var mask_graphics_30 = new cjs.Graphics().p("AIkGuIyLmrQgdgLABgCQBfkCD6hzQD5hzEBBeQECBfBzD6QBzD4hfECIAAAAIg1gRg");
	var mask_graphics_31 = new cjs.Graphics().p("AING+Ixtn0QgcgOABgBQBvj8EBhiQEAhjD7BvQD7BvBjEAQBjEAhwD7IAAAAIg0gVg");
	var mask_graphics_32 = new cjs.Graphics().p("AHzHOIxLo8QgbgPABgCQCAj0EGhSQEFhSD0B/QDzB/BSEGQBTEFh/D0IAAAAIgzgYg");
	var mask_graphics_33 = new cjs.Graphics().p("AHVHdIwjqBQgagRABgCQCPjrEKhBQEKhBDrCPQDrCOBBEKQBCEKiPDrIAAAAIgxgbg");
	var mask_graphics_34 = new cjs.Graphics().p("AG0HrIv3rDQgZgTABgBQCdjiEPgvQENgwDhCdQDiCdAwENQAwEOidDiIAAAAIgwgfg");
	var mask_graphics_35 = new cjs.Graphics().p("AGRH5IvJsDQgXgUABgCQCrjXERgeQEQgeDXCrQDWCrAfEQQAfERirDWIAAAAIgtghg");
	var mask_graphics_36 = new cjs.Graphics().p("AFqIGIuVs/QgWgWABgBQC5jMESgMQERgNDMC4QDLC5ANERQANESi4DLIAAAAIgrgkg");
	var mask_graphics_37 = new cjs.Graphics().p("AFAISItdt4QgVgXABgBQDFi/ETAFQERAEC/DGQC/DFgEERQgEESjFC/IAAAAIgpgng");
	var mask_graphics_38 = new cjs.Graphics().p("AETIeIsiutQgUgZACgBQDRiyERAXQERAWCyDRQCyDRgWERQgWERjRCyIAAAAIgmgqg");
	var mask_graphics_39 = new cjs.Graphics().p("ADkIpIrkvfQgSgZABgBQDcilEQApQEOAnCkDdQCkDbgnEPQgnEPjcCkIAAAAIgjgsg");
	var mask_graphics_40 = new cjs.Graphics().p("ACyI0IqjwNQgQgbACAAQDmiWEMA5QELA5CWDnQCVDlg4EMQg4EMjmCWIAAAAIghgug");
	var mask_graphics_41 = new cjs.Graphics().p("AB/I9Ipgw2QgOgbACgBQDviHEHBLQEIBKCGDvQCHDvhKEHQhJEIjvCHIAAAAIgdgwg");
	var mask_graphics_42 = new cjs.Graphics().p("ABJJFIoZxaQgMgdACAAQD3h3EBBbQEDBbB3D3QB3D3haECQhaEDj3B3IAAAAIgbgyg");
	var mask_graphics_43 = new cjs.Graphics().p("AASJMInQx6QgKgdABgBQD+hnD7BsQD8BrBnD/QBnD9hqD8QhrD9j9BmIAAAAIgYgzg");
	var mask_graphics_44 = new cjs.Graphics().p("AglJSImHyWQgIgeABAAQEFhWDzB7QD1B7BWEFQBXEDh7D1Qh6D1kDBXIAAAAIgUg1g");
	var mask_graphics_45 = new cjs.Graphics().p("AheJXIk7ytQgHgeACAAQEJhGDrCLQDsCLBGEJQBFEJiJDsQiKDtkIBFIAAAAIgQg1g");
	var mask_graphics_46 = new cjs.Graphics().p("AiYJaIjuy+QgEgeABgBQENg0DiCaQDiCZA1EOQA0EMiYDjQiZDkkMA0IAAAAIgMg3g");
	var mask_graphics_47 = new cjs.Graphics().p("AjTJcIifzKQgDgfACAAQEPgjDXCoQDZCoAjEQQAjEPinDZQinDZkOAjIAAAAIgJg4g");
	var mask_graphics_48 = new cjs.Graphics().p("AkOJeIhQzSQgBgfABAAQESgSDLC2QDOC1ARESQASEQi1DOQi0DOkQASIAAAAIgFg4g");
	var mask_graphics_49 = new cjs.Graphics().p("AlJJeIgBzUQABgfACAAQERAADADCQDBDCAAERQAAESjBDCQjADCkRAAIgCg4g");
	var mask_graphics_50 = new cjs.Graphics().p("AldKUIABg4IBMzSQADgfABAAQERARC0DOQC1DNgRERQgRESjNC1Qi6Cnj0AAIgugCg");
	var mask_graphics_51 = new cjs.Graphics().p("AlyKOIAFg4ICXzLQAFgeACAAQEPAiCnDYQCoDYgiEQQgiEQjXCoQizCNjaAAQgsAAgtgGg");
	var mask_graphics_52 = new cjs.Graphics().p("AmGKFIAIg4IDjy/QAHgeABAAQEMAyCaDjQCaDigyEMQgzEOjhCbQipB1jDAAQg/AAhCgMg");
	var mask_graphics_53 = new cjs.Graphics().p("AmaJ4IALg3IEtywQAJgdACAAQEIBDCMDrQCMDrhDEKQhDEJjrCNQieBgitAAQhSAAhVgVg");
	var mask_graphics_54 = new cjs.Graphics().p("AmuJnIAPg3IF2yaQALgdABAAQEEBTB9D0QB9DzhTEFQhTEFjzB+QiSBNiZAAQhkAAhnghg");
	var mask_graphics_55 = new cjs.Graphics().p("AnBJSIASg1IG9yBQAMgcACAAQD/BjBuD7QBuD6hjD/QhkEAj6BvQiDA7iGAAQh3AAh3gvg");
	var mask_graphics_56 = new cjs.Graphics().p("AnUI7IAVg0IIExkQAOgbABAAQD5BzBeEBQBeEBhzD4QhyD5kBBfQhzAshzAAQiKAAiHg+g");
	var mask_graphics_57 = new cjs.Graphics().p("AnnIfIAZgyIJIxCQAQgaABAAQDxCCBOEGQBOEFiBDyQiCDykGBPQhjAfhgAAQidAAiWhRg");
	var mask_graphics_58 = new cjs.Graphics().p("An4IBIAcgxIKKwbQARgaABABQDpCQA9ELQA/EJiRDqQiQDpkJA/QhSAThOAAQiyAAihhkg");
	var mask_graphics_59 = new cjs.Graphics().p("AoJHgIAfgvILJvyQATgYABABQDgCeAtEOQAtEMieDgQifDgkMAvQg+ALg7AAQjIAAish6g");
	var mask_graphics_60 = new cjs.Graphics().p("AoZG7IAigtIMGvEQAUgXABABQDWCsAcEQQAdEPisDWQisDVkPAeQgpAFgnAAQjgAAi1iSg");
	var mask_graphics_61 = new cjs.Graphics().p("AooGUIAkgrINAuSQAWgWABABQDKC4AMERQAMERi5DLQi5DKkQANIglABQj6AAi8irg");
	var mask_graphics_62 = new cjs.Graphics().p("AhnIxQkSgEi+jEIAngoIN3teQAXgUABABQC+DFgFERQgFERjFC/QjBC7kKAAIgKAAg");
	var mask_graphics_63 = new cjs.Graphics().p("AiCIgQkRgViyjPIApgmIOqslQAZgTABABQCyDQgWERQgWEPjQCzQi7CgjuAAQgbAAgcgCg");
	var mask_graphics_64 = new cjs.Graphics().p("AieILQkQglikjaIArgjIParqQAagSABACQClDagnEPQgnEOjbClQiyCHjVAAQgwAAgxgHg");
	var mask_graphics_65 = new cjs.Graphics().p("Ai7H0QkMg2iXjkIAtghIQGqrQAbgQABABQCXDkg4EMQg3EMjkCXQipBwi9AAQhEAAhGgOg");
	var mask_graphics_66 = new cjs.Graphics().p("AjYHZQkJhGiIjtIAvgeIQvprQAbgOABACQCJDthIEHQhIEIjtCJQidBbioAAQhXAAhZgYg");
	var mask_graphics_67 = new cjs.Graphics().p("Aj2G7QkEhWh5j1IAxgbIRTonQAcgNABABQB6D1hZEDQhXEDj2B6QiQBIiTAAQhpAAhsgkg");
	var mask_graphics_68 = new cjs.Graphics().p("AkUGaQj9hmhrj8IAzgYIRyniQAdgLABACQBrD8hoD8QhoD+j8BrQiBA2iBAAQh7AAh9gyg");
	var mask_graphics_69 = new cjs.Graphics().p("AkxF3Qj4h2hakBIA0gUISOmcQAdgJABABQBbECh3D2Qh3D2kDBbQhxAohtAAQiPAAiLhCg");
	var mask_graphics_70 = new cjs.Graphics().p("AlPFRQjwiFhLkGIA2gRISllUQAegHABACQBLEHiHDuQiFDukIBLQhgAchbAAQiiAAiZhVg");
	var mask_graphics_71 = new cjs.Graphics().p("AltEoQjniTg6kKIA2gOIS4kJQAegGABACQA6ELiUDlQiUDmkNA7QhMARhIAAQi4AAilhqg");
	var mask_graphics_72 = new cjs.Graphics().p("AmLD+QjdihgqkOIA3gKITGi/QAfgDAAABQAqEPiiDbQiiDckQArQg4AIg1AAQjOAAiwh/g");
	var mask_graphics_73 = new cjs.Graphics().p("AmoDRQjTivgZkPIA4gHITPhzQAfgCAAACQAZEQiwDRQivDSkRAaQgjADggAAQjoAAi4iYg");
	var mask_graphics_74 = new cjs.Graphics().p("AnFCiQjIi6gIkRIA4gEITUgnQAfAAAAACQAIESi8DFQi8DHkSAJIgXAAQkDAAi/izg");
	var mask_graphics_75 = new cjs.Graphics().p("AgUFUQkSgJi7jHQi8jGAIkRIA4AAITUAlQAfACAAACQgIESjIC5QjACzkDAAIgXAAg");
	var mask_graphics_76 = new cjs.Graphics().p("Ag7FlQkRgZivjSQivjRAZkQIA4ADITQBxQAeAEAAACQgZEPjTCuQi5CZjnAAQghAAgjgEg");
	var mask_graphics_77 = new cjs.Graphics().p("AhgF0QkPgqiijcQiijcAqkOIA4AHITGC9QAeAGAAABQgqEOjeCgQivCAjPAAQg1AAg4gJg");
	var mask_graphics_78 = new cjs.Graphics().p("AiEGBQkMg7iUjmQiUjlA6kLIA4AKIS4EIQAeAHgBACQg6ELjnCSQilBpi4AAQhJAAhMgQg");
	var mask_graphics_79 = new cjs.Graphics().p("AimGKQkIhLiGjvQiGjtBLkHIA3ANISmFSQAdAKAAABQhLEHjwCEQiZBUijAAQhbAAhfgbg");
	var mask_graphics_80 = new cjs.Graphics().p("AjHGRQkChbh3j3Qh3j1BbkCIA2ARISOGaQAdAMgBABQhbECj3B1QiLBCiPAAQhuAAhxgog");
	var mask_graphics_81 = new cjs.Graphics().p("AjlGVQj9hqhnj+Qhoj8Brj8IA1AUIRzHhQAcANgBABQhrD8j+BmQh8Ayh8AAQiAAAiBg3g");
	var mask_graphics_82 = new cjs.Graphics().p("AkCGXQj1h6hYkEQhXkCB5j1IA0AYIRTImQAbAOgBACQh6D1kDBWQhsAkhpAAQiUAAiQhIg");
	var mask_graphics_83 = new cjs.Graphics().p("AkcGWQjuiJhHkJQhHkHCIjsIAyAaIQvJpQAaAQAAACQiJDtkJBGQhaAYhWAAQioAAidhbg");
	var mask_graphics_84 = new cjs.Graphics().p("Ak0GSQjliYg3kLQg3kMCXjkIAwAeIQHKqQAZASAAABQiYDkkMA2QhGAOhEAAQi9AAiphwg");
	var mask_graphics_85 = new cjs.Graphics().p("AlKGLQjbilgmkOQgnkPCljaIAuAgIPbLoQAYAUgBABQilDbkPAkQgyAHgwAAQjUAAiziHg");
	var mask_graphics_86 = new cjs.Graphics().p("AldGCQjQizgWkQQgWkQCyjQIAsAjIOsMkQAWAVgBABQiyDQkRAUQgcACgbAAQjuAAi7igg");
	var mask_graphics_87 = new cjs.Graphics().p("AluF1QjEi+gFkRQgFkSC+jEIAqAmIN4NcQAWAWgCABQi+DFkSADIgKAAQkKAAjCi8g");
	var mask_graphics_88 = new cjs.Graphics().p("ABOI+QkQgNi5jLQi5jKAMkRQAMkRDKi4IAnAoINCORQAUAYgBABQi9Crj5AAIgmgBg");
	var mask_graphics_89 = new cjs.Graphics().p("AA1JIQkPgeisjWQisjVAdkPQAdkRDVirIAlArIMHPCQATAZgCABQi1CSjfAAQgoAAgpgFg");
	var mask_graphics_90 = new cjs.Graphics().p("AAdJPQkNgviejgQifjgAukNQAtkODgieIAiAtILLPxQARAagCABQisB6jHAAQg8AAg+gLg");
	var mask_graphics_91 = new cjs.Graphics().p("AAGJSQkJhAiQjpQiRjpA+kKQA+kKDpiQIAfAvIKLQaQAQAbgCABQihBkixAAQhPAAhSgTg");
	var mask_graphics_92 = new cjs.Graphics().p("AgOJRQkGhPiCjyQiCjyBPkFQBOkGDxiCIAcAxIJKRBQANAcgBABQiVBQidAAQhhAAhjgfg");
	var mask_graphics_93 = new cjs.Graphics().p("AgjJNQkAhfhzj6Qhyj4BekBQBekBD5hyIAZAyIIFRjQAMAdgCABQiHA+iJAAQh0AAh0gsg");
	var mask_graphics_94 = new cjs.Graphics().p("Ag2JGQj6hvhjkAQhjj/Buj7QBuj6D/hjIAWA0IG/SBQAKAdgBABQh4Auh3AAQiGAAiEg7g");
	var mask_graphics_95 = new cjs.Graphics().p("AhHI7Qjzh+hTkGQhTkEB9jzQB9j0EEhTIATA1IF4SbQAIAdgCABQhnAhhkAAQiaAAiRhNg");
	var mask_graphics_96 = new cjs.Graphics().p("AhXItQjriNhDkKQhDkJCMjrQCMjsEIhCIAQA2IEvSvQAGAegCABQhVAVhSAAQitAAiehgg");
	var mask_graphics_97 = new cjs.Graphics().p("AhmIcQjiibgykOQgykNCajiQCajiEMgyIAMA3IDkS/QAFAfgCAAQhCAMg/AAQjDAAiph1g");
	var mask_graphics_98 = new cjs.Graphics().p("AhzIHQjYipgikQQghkPCojYQCnjZEPghIAJA3ICZTMQACAfgBAAQguAFgrAAQjbAAiyiNg");
	var mask_graphics_99 = new cjs.Graphics().p("Ah/HvQjNi1gQkTQgRkQC0jOQC1jNEQgRIAGA4IBNTSQAAAfgBABIguABQj1AAi6ing");
	var mask_graphics_100 = new cjs.Graphics().p("AiJHUQjBjCAAkSQAAkSDBjCQDAjCERAAIACA5IABTVQgBAfgCAAQkRAAjAjDg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:-33.5267,y:-0.15}).wait(1).to({graphics:mask_graphics_1,x:-31.5376,y:-0.2481}).wait(1).to({graphics:mask_graphics_2,x:-29.4338,y:-0.4975}).wait(1).to({graphics:mask_graphics_3,x:-27.3454,y:-0.888}).wait(1).to({graphics:mask_graphics_4,x:-25.2776,y:-1.4112}).wait(1).to({graphics:mask_graphics_5,x:-23.2353,y:-2.0605}).wait(1).to({graphics:mask_graphics_6,x:-21.2245,y:-2.8302}).wait(1).to({graphics:mask_graphics_7,x:-19.2528,y:-3.7158}).wait(1).to({graphics:mask_graphics_8,x:-17.329,y:-4.7141}).wait(1).to({graphics:mask_graphics_9,x:-15.4634,y:-5.8229}).wait(1).to({graphics:mask_graphics_10,x:-13.6675,y:-7.0413}).wait(1).to({graphics:mask_graphics_11,x:-11.9546,y:-8.3699}).wait(1).to({graphics:mask_graphics_12,x:-10.3397,y:-9.8109}).wait(1).to({graphics:mask_graphics_13,x:-8.8422,y:-11.3667}).wait(1).to({graphics:mask_graphics_14,x:-7.4618,y:-13.0265}).wait(1).to({graphics:mask_graphics_15,x:-6.1937,y:-14.7743}).wait(1).to({graphics:mask_graphics_16,x:-5.0364,y:-16.5959}).wait(1).to({graphics:mask_graphics_17,x:-3.9899,y:-18.4791}).wait(1).to({graphics:mask_graphics_18,x:-3.0554,y:-20.413}).wait(1).to({graphics:mask_graphics_19,x:-2.2353,y:-22.3881}).wait(1).to({graphics:mask_graphics_20,x:-1.5333,y:-24.3963}).wait(1).to({graphics:mask_graphics_21,x:-0.9538,y:-26.4304}).wait(1).to({graphics:mask_graphics_22,x:-0.5028,y:-28.484}).wait(1).to({graphics:mask_graphics_23,x:-0.1872,y:-30.5488}).wait(1).to({graphics:mask_graphics_24,x:-0.0158,y:-32.5928}).wait(1).to({graphics:mask_graphics_25,x:0.0414,y:-32.6563}).wait(1).to({graphics:mask_graphics_26,x:0.2131,y:-30.5553}).wait(1).to({graphics:mask_graphics_27,x:0.5288,y:-28.4597}).wait(1).to({graphics:mask_graphics_28,x:0.9794,y:-26.384}).wait(1).to({graphics:mask_graphics_29,x:1.5576,y:-24.3325}).wait(1).to({graphics:mask_graphics_30,x:2.2574,y:-22.3106}).wait(1).to({graphics:mask_graphics_31,x:3.0738,y:-20.325}).wait(1).to({graphics:mask_graphics_32,x:4.003,y:-18.3836}).wait(1).to({graphics:mask_graphics_33,x:5.0425,y:-16.496}).wait(1).to({graphics:mask_graphics_34,x:6.1908,y:-14.6729}).wait(1).to({graphics:mask_graphics_35,x:7.4476,y:-12.9266}).wait(1).to({graphics:mask_graphics_36,x:8.8145,y:-11.2712}).wait(1).to({graphics:mask_graphics_37,x:10.2947,y:-9.7238}).wait(1).to({graphics:mask_graphics_38,x:11.8862,y:-8.2961}).wait(1).to({graphics:mask_graphics_39,x:13.5739,y:-6.9813}).wait(1).to({graphics:mask_graphics_40,x:15.3428,y:-5.7768}).wait(1).to({graphics:mask_graphics_41,x:17.1799,y:-4.6817}).wait(1).to({graphics:mask_graphics_42,x:19.0738,y:-3.6968}).wait(1).to({graphics:mask_graphics_43,x:21.0145,y:-2.8236}).wait(1).to({graphics:mask_graphics_44,x:22.9932,y:-2.0653}).wait(1).to({graphics:mask_graphics_45,x:25.0025,y:-1.4256}).wait(1).to({graphics:mask_graphics_46,x:27.0357,y:-0.9097}).wait(1).to({graphics:mask_graphics_47,x:29.0864,y:-0.5239}).wait(1).to({graphics:mask_graphics_48,x:31.1412,y:-0.2757}).wait(1).to({graphics:mask_graphics_49,x:33.1139,y:-0.05}).wait(1).to({graphics:mask_graphics_50,x:31.2164,y:0.0372}).wait(1).to({graphics:mask_graphics_51,x:29.2081,y:0.2603}).wait(1).to({graphics:mask_graphics_52,x:27.2158,y:0.6108}).wait(1).to({graphics:mask_graphics_53,x:25.2439,y:1.0818}).wait(1).to({graphics:mask_graphics_54,x:23.2964,y:1.6674}).wait(1).to({graphics:mask_graphics_55,x:21.3782,y:2.3629}).wait(1).to({graphics:mask_graphics_56,x:19.4953,y:3.1644}).wait(1).to({graphics:mask_graphics_57,x:17.655,y:4.0692}).wait(1).to({graphics:mask_graphics_58,x:15.8659,y:5.0753}).wait(1).to({graphics:mask_graphics_59,x:14.1375,y:6.1817}).wait(1).to({graphics:mask_graphics_60,x:12.4809,y:7.3887}).wait(1).to({graphics:mask_graphics_61,x:10.9084,y:8.6979}).wait(1).to({graphics:mask_graphics_62,x:9.4355,y:10.1124}).wait(1).to({graphics:mask_graphics_63,x:8.0721,y:11.6309}).wait(1).to({graphics:mask_graphics_64,x:6.8118,y:13.2402}).wait(1).to({graphics:mask_graphics_65,x:5.6523,y:14.927}).wait(1).to({graphics:mask_graphics_66,x:4.593,y:16.6796}).wait(1).to({graphics:mask_graphics_67,x:3.6341,y:18.4876}).wait(1).to({graphics:mask_graphics_68,x:2.7774,y:20.3419}).wait(1).to({graphics:mask_graphics_69,x:2.0251,y:22.2344}).wait(1).to({graphics:mask_graphics_70,x:1.3808,y:24.1582}).wait(1).to({graphics:mask_graphics_71,x:0.8488,y:26.1071}).wait(1).to({graphics:mask_graphics_72,x:0.4344,y:28.0755}).wait(1).to({graphics:mask_graphics_73,x:0.144,y:30.0555}).wait(1).to({graphics:mask_graphics_74,x:-0.0145,y:32.0159}).wait(1).to({graphics:mask_graphics_75,x:-0.0685,y:32.0841}).wait(1).to({graphics:mask_graphics_76,x:-0.2266,y:30.0767}).wait(1).to({graphics:mask_graphics_77,x:-0.5162,y:28.0733}).wait(1).to({graphics:mask_graphics_78,x:-0.9296,y:26.0886}).wait(1).to({graphics:mask_graphics_79,x:-1.4605,y:24.1262}).wait(1).to({graphics:mask_graphics_80,x:-2.1035,y:22.1905}).wait(1).to({graphics:mask_graphics_81,x:-2.8543,y:20.2869}).wait(1).to({graphics:mask_graphics_82,x:-3.7098,y:18.4222}).wait(1).to({graphics:mask_graphics_83,x:-4.6674,y:16.6042}).wait(1).to({graphics:mask_graphics_84,x:-5.7257,y:14.842}).wait(1).to({graphics:mask_graphics_85,x:-6.8843,y:13.1459}).wait(1).to({graphics:mask_graphics_86,x:-8.1442,y:11.5276}).wait(1).to({graphics:mask_graphics_87,x:-9.5075,y:10.0002}).wait(1).to({graphics:mask_graphics_88,x:-10.9773,y:8.5809}).wait(1).to({graphics:mask_graphics_89,x:-12.545,y:7.2673}).wait(1).to({graphics:mask_graphics_90,x:-14.1968,y:6.0556}).wait(1).to({graphics:mask_graphics_91,x:-15.92,y:4.9442}).wait(1).to({graphics:mask_graphics_92,x:-17.7036,y:3.933}).wait(1).to({graphics:mask_graphics_93,x:-19.538,y:3.023}).wait(1).to({graphics:mask_graphics_94,x:-21.4145,y:2.2162}).wait(1).to({graphics:mask_graphics_95,x:-23.3256,y:1.5155}).wait(1).to({graphics:mask_graphics_96,x:-25.2648,y:0.9248}).wait(1).to({graphics:mask_graphics_97,x:-27.2264,y:0.449}).wait(1).to({graphics:mask_graphics_98,x:-29.2042,y:0.0938}).wait(1).to({graphics:mask_graphics_99,x:-31.1849,y:-0.1336}).wait(1).to({graphics:mask_graphics_100,x:-33.1267,y:-0.1}).wait(1));

	// Layer_2
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#0F97FF").s().p("AnUO0IgLAAIAA9nIALAAIABAAQGGAEEUESQEZEVAAGIQAAGJkZEVQkUERmGAFg");
	this.shape_2.setTransform(-0.05,0,0.7066,0.7066,0,0,0,-48.1,0);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#0F97FF").s().p("AAALAQkiAAjPjOQjOjOAAkkQAAkiDOjOQDPjPEiAAQEkAADODPQDODOAAEiQAAEkjODOQjODOkkAAIAAAAg");
	this.shape_3.setTransform(0.0476,0.1358,0.9404,0.9404);

	var maskedShapeInstanceList = [this.shape_2,this.shape_3];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2}]}).to({state:[{t:this.shape_3}]},49).wait(52));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-98.8,-98.8,197.7,197.7);


(lib.TutorialHUDButtons = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.SpotterTimerOutline();
	this.instance.setTransform(469.4,39.65);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_3
	this.TimerFill = new lib.TimerFill("single",59);
	this.TimerFill.name = "TimerFill";
	this.TimerFill.setTransform(540.85,111.15);

	this.timeline.addTween(cjs.Tween.get(this.TimerFill).wait(1));

	// Timer
	this.instance_1 = new lib.SpotterTimerBG();
	this.instance_1.setTransform(469.4,39.65);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// buttonSubmit
	this.buttonSubmit = new cjs.Text("Next", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.buttonSubmit.name = "buttonSubmit";
	this.buttonSubmit.textAlign = "center";
	this.buttonSubmit.lineHeight = 79;
	this.buttonSubmit.lineWidth = 341;
	this.buttonSubmit.parent = this;
	this.buttonSubmit.setTransform(234.35,73.4);
ranj.TextOffsetFixer.fix(this.buttonSubmit);

	this.instance_2 = new lib.MainButtonUp();
	this.instance_2.setTransform(24.85,47.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.buttonSubmit}]}).wait(1));

	// buttonClear
	this.buttonClear = new cjs.Text("Rückgängig \nmachen", "42px 'Poppins SemiBold'", "#0F5184");
	this.buttonClear.name = "buttonClear";
	this.buttonClear.textAlign = "right";
	this.buttonClear.lineHeight = 42;
	this.buttonClear.lineWidth = 319;
	this.buttonClear.parent = this;
	this.buttonClear.setTransform(937.15,55.5);
ranj.TextOffsetFixer.fix(this.buttonClear);

	this.icon = new lib.UndoButtonIcon();
	this.icon.name = "icon";
	this.icon.setTransform(977.1,105.65,0.875,0.875,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.icon},{t:this.buttonClear}]}).wait(1));

	// bg
	this.instance_3 = new lib.BottomFloatingPanelBG();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialHUDButtons, new cjs.Rectangle(0,-22.4,1085,236.4), null);


(lib.splashTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(743.45,501.8,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("InstructionsInstructionsInstructionsInstructi", "40px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "right";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 894;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(950,343.798);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Thanks for your effort!", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "right";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(950.25,51.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// panelBG
	this.instance = new lib.EndscreenBGPanel();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.splashTextPanel, new cjs.Rectangle(0,0,1002,609), null);


(lib.SelectionPulseAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SelectionPulse();
	this.instance.setTransform(0,0,0.6905,0.6905);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1,scaleY:1},59).to({scaleX:0.6905,scaleY:0.6905},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105,-105,210,210);


(lib.FloatyAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_16 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(16).call(this.frame_16).wait(1));

	// Layer_1
	this.selectIndicator = new lib.Floaty();
	this.selectIndicator.name = "selectIndicator";
	this.selectIndicator.setTransform(0,-104.5);
	this.selectIndicator.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.selectIndicator).to({y:21.35,alpha:1},9).to({y:-7},4).to({y:0},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-49.3,-208.9,100,282.7);


(lib.FishingSpotAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Pt2 copy
	this.instance = new lib.FishingSpot_pt2();
	this.instance.setTransform(0,0,0.4191,0.4191);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(114).to({_off:false},0).to({scaleX:0.5569,scaleY:0.5569,alpha:1},35).wait(1));

	// Pt1 copy
	this.instance_1 = new lib.FishingSpot_pt1();
	this.instance_1.setTransform(0,0,0.7143,0.7143);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(114).to({_off:false},0).to({scaleX:0.782,scaleY:0.782,alpha:1},35).wait(1));

	// Bubbles copy
	this.instance_2 = new lib.FishingSpot_Bubble();
	this.instance_2.setTransform(0,0,0.5581,0.5546);
	this.instance_2.alpha = 0;
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(114).to({_off:false},0).to({scaleX:0.663,scaleY:0.6602,x:-0.05,y:0.1,alpha:1},35).wait(1));

	// Pt4 copy
	this.instance_3 = new lib.FishingSpot_pt4();
	this.instance_3.setTransform(-0.1,-0.1,0.87,0.87,0,0,0,-0.4,-0.4);
	this.instance_3.alpha = 0.3203;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).to({regX:0,regY:0,scaleX:1,scaleY:1,x:0,y:0,alpha:0},35).wait(115));

	// Pt3 copy
	this.instance_4 = new lib.FishingSpot_pt3();
	this.instance_4.setTransform(-0.1,-0.1,0.8395,0.8395,0,0,0,-0.6,-0.6);
	this.instance_4.alpha = 0.3203;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:0,regY:0,scaleX:1,scaleY:1,x:0,y:0,alpha:0},35).wait(115));

	// Bubbles2 copy
	this.instance_5 = new lib.FishingSpot_Bubble();
	this.instance_5.setTransform(-0.25,0.45,0.8951,0.8943);
	this.instance_5.alpha = 0.3203;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({scaleX:1,scaleY:1,y:0.5,alpha:0},35).wait(115));

	// Pt4
	this.instance_6 = new lib.FishingSpot_pt4();
	this.instance_6.setTransform(-0.25,-0.25,0.4523,0.4523,0,0,0,-0.5,-0.5);
	this.instance_6.alpha = 0;
	this.instance_6._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(57).to({_off:false},0).to({regX:-0.4,regY:-0.4,scaleX:0.5916,scaleY:0.5916,x:-0.15,y:-0.15,alpha:1},32).to({scaleX:0.87,scaleY:0.87,x:-0.1,y:-0.1,alpha:0.3203},60).wait(1));

	// Pt3
	this.instance_7 = new lib.FishingSpot_pt3();
	this.instance_7.setTransform(-0.2,-0.2,0.3238,0.3238,0,0,0,-0.6,-0.6);
	this.instance_7.alpha = 0;
	this.instance_7._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(57).to({_off:false},0).to({scaleX:0.4957,scaleY:0.4957,alpha:1},32).to({scaleX:0.8395,scaleY:0.8395,x:-0.1,y:-0.1,alpha:0.3203},60).wait(1));

	// Bubbles2
	this.instance_8 = new lib.FishingSpot_Bubble();
	this.instance_8.setTransform(0,0,0.5581,0.5546);
	this.instance_8.alpha = 0;
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(57).to({_off:false},0).to({scaleX:0.6705,scaleY:0.6678,x:-0.05,y:0.15,alpha:1},32).to({scaleX:0.8951,scaleY:0.8943,x:-0.25,y:0.45,alpha:0.3203},60).wait(1));

	// Pt2
	this.instance_9 = new lib.FishingSpot_pt2();
	this.instance_9.setTransform(0,0,0.5569,0.5569);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).to({scaleX:1,scaleY:1,alpha:0},79).wait(71));

	// Pt1
	this.instance_10 = new lib.FishingSpot_pt1();
	this.instance_10.setTransform(0,0,0.782,0.782);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({scaleX:1,scaleY:1,alpha:0},79).wait(71));

	// Bubbles
	this.instance_11 = new lib.FishingSpot_Bubble();
	this.instance_11.setTransform(-0.05,0.1,0.663,0.6602);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).to({scaleX:1,scaleY:1,x:-0.25,y:0.5,alpha:0},79).wait(71));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105,-105,210.1,210.1);


(lib.FishPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.Fish7D();
	this.instance.setTransform(-0.2,-113.2,1,1,0,0,0,-0.2,-113.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishPlaceholder, new cjs.Rectangle(-113,-226,225.5,225.5), null);


(lib.DarkPulseAnimation = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.DarkPulse();
	this.instance.setTransform(0,0,0.6905,0.6905);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1,scaleY:1},59).to({scaleX:0.6905,scaleY:0.6905},60).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105,-112,210,210);


(lib.GenericPopup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// continueButton
	this.continueButton = new lib.SubmitButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-235.55,279.8,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// cancelButton
	this.cancelButton = new lib.SubmitButton();
	this.cancelButton.name = "cancelButton";
	this.cancelButton.setTransform(240.9,279.45,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.cancelButton).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("InstructionsInstructionsInstructionsInstructi", "40px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "right";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 894;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(442.2,-31.2002);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Thanks for your effort!", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "right";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(442.25,-268.55);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// panelBG
	this.instance = new lib.EndscreenBGPanelLonger();
	this.instance.setTransform(-501,-320);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(15,151,255,0.498)").s().p("EhoSDBcMAAAjhtMDQlAAAMAAADhtgEhoSin/IAA5cMDQlAAAIAAZcMjQlAAAMDQlAAAMAAACHuMjQlAAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GenericPopup, new cjs.Rectangle(-667.5,-1238,1335,2476), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Professor
	this.instance = new lib.ProfessorRod();
	this.instance.setTransform(379.05,278.5,0.2846,0.2854,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// textPanel
	this.textPanel = new lib.splashTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-2,-470.5,1,1,0,0,0,501,369.5);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// bg
	this.instance_1 = new lib.Splashscreen();
	this.instance_1.setTransform(-667,-980,0.5,0.5);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance_1}]}).wait(1));

	// Background
	this.bg_1 = new lib.Background();
	this.bg_1.name = "bg_1";

	this.timeline.addTween(cjs.Tween.get(this.bg_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1286,1746.9,3400), null);


(lib.TutorialBackground4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// TutorialHUDButtons
	this.tutButtons = new lib.TutorialHUDButtons();
	this.tutButtons.name = "tutButtons";
	this.tutButtons.setTransform(-69,485.3,0.7659,0.7659,0,0,0,433.4,77.3);

	this.timeline.addTween(cjs.Tween.get(this.tutButtons).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackground4, new cjs.Rectangle(-400.9,426.1,801.0999999999999,163.89999999999998), null);


(lib.ProgressDot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_16 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(16).call(this.frame_16).wait(1));

	// Layer_4
	this.instance = new lib.Dot("synched",0);
	this.instance.setTransform(0,0,0.6451,0.6451);
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.2903,scaleY:1.2903,alpha:1},16).wait(1));

	// Layer_1
	this.instance_1 = new lib.ProgressDotTween("synched",0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.3226,scaleY:1.3226},16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-12.9,-12.9,25.8,25.8);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// practice indicator
	this.practiceIndicator = new lib.PracticeIndicatorSkin();
	this.practiceIndicator.name = "practiceIndicator";
	this.practiceIndicator.setTransform(13.9,-0.2);

	this.timeline.addTween(cjs.Tween.get(this.practiceIndicator).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-477.1,-59.7,982,119), null);


(lib.FishPlaceholder_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// circle
	this.instance_1 = new lib.Fish1E();
	this.instance_1.setTransform(-0.65,-113.65,1.3304,1.3304,0,0,0,-0.3,-113.2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FishPlaceholder_1, new cjs.Rectangle(-150.6,-263.7,300,300), null);


(lib.UndoButton2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Rückgängig \nmachen", "42px 'Poppins SemiBold'", "#0F5184");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 42;
	this.upLabelTextField.lineWidth = 319;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-86.75,-62.35);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Rückgängig \nmachen", "42px 'Poppins SemiBold'");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 42;
	this.overLabelTextField.lineWidth = 319;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-86.75,-62.35);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Rückgängig \nmachen", "42px 'Poppins SemiBold'");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 42;
	this.downLabelTextField.lineWidth = 319;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-86.75,-62.35);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Rückgängig \nmachen", "42px 'Poppins SemiBold'", "#DDE5EF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 42;
	this.disabledLabelTextField.lineWidth = 319;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-86.75,-62.35);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Icon
	this.icon = new lib.UndoButtonIcon();
	this.icon.name = "icon";
	this.icon.setTransform(-45.8,-10.2,0.875,0.875,0,0,180);

	this.icon_1 = new lib.UndoButtonIconHi();
	this.icon_1.name = "icon_1";
	this.icon_1.setTransform(-45.8,-10.2,0.875,0.875,0,0,180);

	this.icon_2 = new lib.UndoButtonIconDis();
	this.icon_2.name = "icon_2";
	this.icon_2.setTransform(-45.8,-10.2,0.875,0.875,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.icon}]}).to({state:[{t:this.icon_1}]},1).to({state:[{t:this.icon_2}]},2).wait(1));

	// hitarea
	this.hitarea = new lib.hitArea();
	this.hitarea.name = "hitarea";
	this.hitarea.setTransform(-254.8,-3.6,2.3049,2.4884,0,0,0,59.2,20.7);
	this.hitarea.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hitarea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-408,-64.3,387.2,120);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 43;
	this.upLabelTextField.lineWidth = 276;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-164,-29);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#0F5184");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 43;
	this.overLabelTextField.lineWidth = 276;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-164,-29);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 43;
	this.downLabelTextField.lineWidth = 276;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-164,-29);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "45px 'Poppins SemiBold'", "#DDE5EF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 43;
	this.disabledLabelTextField.lineWidth = 276;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-164,-29);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.BackUp();
	this.instance.setTransform(-102,24,1,1,180);

	this.instance_1 = new lib.BackDown();
	this.instance_1.setTransform(-102,24,1,1,180);

	this.instance_2 = new lib.BackDisabled();
	this.instance_2.setTransform(-102,24,1,1,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-278.05,0.3,2.8787,1.5699,0,0,0,0.1,0.1);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-454.6,-31,352.6,83.3);


(lib.TimerIntroduction = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Fill
	this.TimerFill = new lib.TimerFillIntroduction();
	this.TimerFill.name = "TimerFill";
	this.TimerFill.setTransform(-75.4,0,1,1,0,0,0,-81,0);

	this.timeline.addTween(cjs.Tween.get(this.TimerFill).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimerIntroduction, new cjs.Rectangle(-93.2,-98.8,235.39999999999998,235.39999999999998), null);


(lib.Timer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// border
	this.instance = new lib.SpotterTimerOutline();
	this.instance.setTransform(-71.5,-71.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Fill
	this.TimerFill = new lib.TimerFill();
	this.TimerFill.name = "TimerFill";
	this.TimerFill.setTransform(-0.05,0);

	this.timeline.addTween(cjs.Tween.get(this.TimerFill).wait(1));

	// bg
	this.instance_1 = new lib.SpotterTimerBG();
	this.instance_1.setTransform(-71.5,-71.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Timer, new cjs.Rectangle(-71.5,-71.5,143,143), null);


(lib.Textballoon2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {normal:0,"correct":1,"incorrect":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// fish
	this.fish = new lib.FishPlaceholder_1();
	this.fish.name = "fish";
	this.fish.setTransform(226,69.9,0.7419,0.7417,0,0,0,-0.5,-30.4);

	this.timeline.addTween(cjs.Tween.get(this.fish).wait(3));

	// slicedPanel
	this.slicedPanel = new lib.TextBalloon2Slice9Panel();
	this.slicedPanel.name = "slicedPanel";
	this.slicedPanel.setTransform(1.45,0);

	this.timeline.addTween(cjs.Tween.get(this.slicedPanel).wait(3));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-396.5,-103.1,741,222.5);


(lib.PuddleButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,selectedOver:5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// floaty
	this.selectIndicator = new lib.FloatyAnimation();
	this.selectIndicator.name = "selectIndicator";
	this.selectIndicator.setTransform(133.9,-27.8);
	this.selectIndicator._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectIndicator).wait(6).to({_off:false},0).wait(2));

	// splashes
	this.instance = new lib.FishingSpotAnimation();
	this.instance.setTransform(48.75,37);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(3).to({alpha:0.5},0).wait(1).to({alpha:1},0).wait(4));

	// state highlight
	this.instance_1 = new lib.SelectionPulseAnimation();
	this.instance_1.setTransform(49,37);

	this.instance_2 = new lib.DarkPulseAnimation();
	this.instance_2.setTransform(49,37);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[]},1).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-42.3,-236.7,226.89999999999998,365.29999999999995);


(lib.Hotspot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// fishSlot
	this.fish = new lib.FishPlaceholder();
	this.fish.name = "fish";
	this.fish.setTransform(106.05,97,1,1,0,0,0,106.5,52.5);

	this.timeline.addTween(cjs.Tween.get(this.fish).wait(1));

	// puddle
	this.puddleButton = new lib.PuddleButton();
	this.puddleButton.name = "puddleButton";
	this.puddleButton.setTransform(-0.45,39,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get(this.puddleButton).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hotspot, new cjs.Rectangle(-113.4,-181.5,225.5,310.1), null);


(lib.GateKeeperOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// lines
	this.lines = new lib.GateKeeperOverlayLines();
	this.lines.name = "lines";
	this.lines.setTransform(-34.45,-587);

	this.timeline.addTween(cjs.Tween.get(this.lines).wait(1));

	// titleTextfield
	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "right";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(433.9494,-769.15);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "right";
	this.bodyTextfield.lineHeight = 66;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(433.9,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// button2
	this.button2 = new lib.StartGameButton();
	this.button2.name = "button2";
	this.button2.setTransform(-263,730,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.button2).wait(1));

	// button1
	this.button1 = new lib.PrevButton();
	this.button1.name = "button1";
	this.button1.setTransform(523.3,720.5,1,1,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button1).wait(1));

	// panel bg
	this.bg = new lib.GatekeeperBackground();
	this.bg.name = "bg";
	this.bg.setTransform(0,0,1,1,0,0,0,540,871.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(17.95,-4.4,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperOverlaySkin, new cjs.Rectangle(-720.1,-1180.2,1803.5,2300.5), null);


(lib.TutorialGameBackground5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(-12.05,76.65,0.83,0.83,0,0,0,-0.1,0.2);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// Layer_2
	this.instance = new lib.Fishingtut5();
	this.instance.setTransform(-431,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground5, new cjs.Rectangle(-667.5,-1238,1335.4,2476), null);


(lib.TutorialGameBackground3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// game
	this.textballoon = new lib.Textballoon2();
	this.textballoon.name = "textballoon";
	this.textballoon.setTransform(120.6,333.4);

	this.instance = new lib.ProfNeutral_Closed();
	this.instance.setTransform(-254.45,108.1,0.2495,0.2495,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.textballoon}]}).wait(1));

	// Layer_2
	this.instance_1 = new lib.Fishingtut2();
	this.instance_1.setTransform(-411,0);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialGameBackground3, new cjs.Rectangle(-667.5,-1238,1335.4,2476), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot5 = new lib.ProgressDot();
	this.dot5.name = "dot5";
	this.dot5.setTransform(112.15,0.15);

	this.dot3 = new lib.ProgressDot();
	this.dot3.name = "dot3";
	this.dot3.setTransform(56.15,0.15);

	this.dot4 = new lib.ProgressDot();
	this.dot4.name = "dot4";
	this.dot4.setTransform(84.15,0.15);

	this.dot2 = new lib.ProgressDot();
	this.dot2.name = "dot2";
	this.dot2.setTransform(28.25,0.05);

	this.dot0 = new lib.ProgressDot();
	this.dot0.name = "dot0";
	this.dot0.setTransform(-28.15,0);

	this.dot1 = new lib.ProgressDot();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-0.15,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot1},{t:this.dot0},{t:this.dot2},{t:this.dot4},{t:this.dot3},{t:this.dot5}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-37.1,-9,158.3,18.2), null);


(lib.HudBottom = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Timer
	this.Timer = new lib.Timer();
	this.Timer.name = "Timer";
	this.Timer.setTransform(536.9,111.15);

	this.timeline.addTween(cjs.Tween.get(this.Timer).wait(1));

	// buttonNext
	this.buttonNext = new lib.StartGameButton();
	this.buttonNext.name = "buttonNext";
	this.buttonNext.setTransform(244.95,110.5,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.buttonNext).wait(1));

	// buttonSubmit
	this.buttonSubmit = new lib.SubmitButton();
	this.buttonSubmit.name = "buttonSubmit";
	this.buttonSubmit.setTransform(244.8,110.65,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.buttonSubmit).wait(1));

	// buttonClear
	this.buttonClear = new lib.UndoButton2();
	this.buttonClear.name = "buttonClear";
	this.buttonClear.setTransform(1023.9,117.4,1,1,0,0,0,0.7,-0.6);

	this.timeline.addTween(cjs.Tween.get(this.buttonClear).wait(1));

	// text short
	this.text = new cjs.Text("", "14px 'Poppins-Regular'", "#0F5184");
	this.text.textAlign = "center";
	this.text.lineHeight = 25;
	this.text.lineWidth = 100;
	this.text.parent = this;
	this.text.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	// text
	this.text_1 = new cjs.Text("", "14px 'Roboto-Medium'", "#0F5184");
	this.text_1.textAlign = "center";
	this.text_1.lineHeight = 17;
	this.text_1.lineWidth = 100;
	this.text_1.parent = this;
	this.text_1.setTransform(65.2,4.3);
ranj.TextOffsetFixer.fix(this.text_1);

	this.timeline.addTween(cjs.Tween.get(this.text_1).wait(1));

	// bg
	this.instance = new lib.BottomFloatingPanelBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HudBottom, new cjs.Rectangle(0,0,1046,214), null);


(lib.Pond14 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(414.6,280.85,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(39.2,103,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(353.05,-81.3,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(60.1,-189.05,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-293.4,-145.8,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(-37.35,-455.9,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(-334.85,-476.45,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel14s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond14, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond13 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(170.4,340.55,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(92.65,-71.3,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-83.85,192.45,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-334.85,46.45,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(0.55,-405.5,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot3},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel13s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// hotspots
	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-320.55,-466.05,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(443.25,-81.3,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot2},{t:this.spot4}]}).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond13, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond12 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(189.8,289.05,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(435.95,-89.6,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(443.25,220.5,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-293.4,-442,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-320.55,-131.9,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(19.35,68.55,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(359.2,-442,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel12s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond12, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(464.1,-117.3,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(185.55,-24.25,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-39.95,139.75,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(100.25,-367.35,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-125.25,-226.2,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(258.4,323.15,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(-293.4,-486.05,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel11s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond11, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond10 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(140.7,361.75,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(-107.9,-502.9,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(182.5,-438.3,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-364.85,-392.75,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-208.65,-158.2,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(-382.1,83.7,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel10s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// hotspots
	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(455.1,-516.55,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get(this.spot1).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond10, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(200.7,333.75,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(479.3,-496.9,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-63.9,183.2,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-320.55,37.75,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(61.1,-165.5,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(384.85,37.75,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(-229.5,-456.05,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel09s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond9, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,467.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(-72.25,297.7,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(309.9,-478.9,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-343.05,163.05,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(469.25,-280.9,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-343.05,-158.35,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(-92.9,19.15,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(84.9,-505.9,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel08s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond8, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(255.85,317.95,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(63.9,72.25,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-161.6,276.1,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-320.55,7.85,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(443.25,34.9,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot2},{t:this.spot3},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel07s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// hotspots
	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-334.85,-500.8,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(425.95,-516.8,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot4}]}).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond7, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(422.3,303.3,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(468.3,-284.85,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-141.55,212.05,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-268.7,-349.7,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-318.65,-6.75,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(170.45,163.05,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel05s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// hotspots
	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(196.3,-473.7,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get(this.spot1).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond6, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(464.1,202.45,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(-59.8,-201,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-59.8,157,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-325.95,-337.85,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-334.85,8.95,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(206.4,332.95,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(206.4,8.95,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel06s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond5, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(428.7,223.6,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(449.95,-126.35,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-135.9,153.85,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(142.65,299.4,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-308.5,-106.85,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(142.65,-52.5,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(142.65,-352.55,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel04s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond4, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(52.1,312,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(435.95,-24.4,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(364.1,285.7,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(-324.85,-79.3,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel03s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// hotspots
	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(-199,-322.5,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(122.6,-143.9,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(52.1,-501.55,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot5},{t:this.spot6}]}).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond3, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(537.7,665.15,1,1,0,0,0,384.5,184.7);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot7 = new lib.Hotspot();
	this.spot7.name = "spot7";
	this.spot7.setTransform(58.65,-493.35,1,1,0,0,0,57,39);

	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(402,-57.25,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-43.55,-209.45,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(-334.85,-52.85,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-190.85,217.25,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(221.95,345.35,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6},{t:this.spot7}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel02s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// hotspots
	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(313.8,-375.65,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get(this.spot1).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond2, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.Pond1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Textballoon
	this.textBalloon = new lib.Textballoon2();
	this.textBalloon.name = "textBalloon";
	this.textBalloon.setTransform(153.2,480.45);

	this.timeline.addTween(cjs.Tween.get(this.textBalloon).wait(1));

	// professor
	this.professor = new lib.Professor01();
	this.professor.name = "professor";
	this.professor.setTransform(-371.8,437.6,1,1,0,0,180,47,-167.8);

	this.timeline.addTween(cjs.Tween.get(this.professor).wait(1));

	// hotspots
	this.spot6 = new lib.Hotspot();
	this.spot6.name = "spot6";
	this.spot6.setTransform(335.5,329.55,1,1,0,0,0,57,39);

	this.spot5 = new lib.Hotspot();
	this.spot5.name = "spot5";
	this.spot5.setTransform(-106.6,168.55,1,1,0,0,0,57,39);

	this.spot4 = new lib.Hotspot();
	this.spot4.name = "spot4";
	this.spot4.setTransform(170.45,69.1,1,1,0,0,0,57,39);

	this.spot3 = new lib.Hotspot();
	this.spot3.name = "spot3";
	this.spot3.setTransform(-246.35,-86.85,1,1,0,0,0,57,39);

	this.spot2 = new lib.Hotspot();
	this.spot2.name = "spot2";
	this.spot2.setTransform(56.3,-231,1,1,0,0,0,57,39);

	this.spot1 = new lib.Hotspot();
	this.spot1.name = "spot1";
	this.spot1.setTransform(311.2,-396.95,1,1,0,0,0,57,39);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.spot1},{t:this.spot2},{t:this.spot3},{t:this.spot4},{t:this.spot5},{t:this.spot6}]}).wait(1));

	// bg new
	this.instance = new lib.BackgroundLevel01s();
	this.instance.setTransform(-666.5,-1054);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhotCzrMAAAlnVMDRbAAAMAAAFnVg");
	this.shape.setTransform(2.7,-88.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Pond1, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(-238.65,729.65,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(5));

	// nextButton
	this.nextButton = new lib.StartGameButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(-238.8,730,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.nextButton).wait(5));

	// prevButton
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(511.3,719.5,1,1,0,0,0,-41,0.1);

	this.timeline.addTween(cjs.Tween.get(this.prevButton).wait(5));

	// Progress dots
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(12.35,728.9,0.9,0.9,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(5));

	// titleTextfield
	this.titleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 82px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.textAlign = "right";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 941;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(433.6994,-768.95);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(5));

	// bodyTextfield
	this.bodyTextfield = new cjs.Text("• [Instructions]", "39px 'Pristina'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "right";
	this.bodyTextfield.lineHeight = 48;
	this.bodyTextfield.lineWidth = 857;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(433.9,-506.65);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(5));

	// Line1
	this.lines1 = new lib.TutorialLines1();
	this.lines1.name = "lines1";
	this.lines1.setTransform(5.4,-616.3,1,1,0,0,0,0,-633.6);

	this.timeline.addTween(cjs.Tween.get(this.lines1).wait(5));

	// Line2
	this.lines2 = new lib.TutorialLines3();
	this.lines2.name = "lines2";
	this.lines2.setTransform(-260.8,-590);

	this.timeline.addTween(cjs.Tween.get(this.lines2).wait(5));

	// Line3
	this.lines3 = new lib.TutorialLines2();
	this.lines3.name = "lines3";
	this.lines3.setTransform(5.2,-609.1,1,1,0,0,0,-0.1,-603.1);

	this.timeline.addTween(cjs.Tween.get(this.lines3).wait(5));

	// Line4
	this.lines4 = new lib.TutorialLines4();
	this.lines4.name = "lines4";
	this.lines4.setTransform(-34.45,-449.4);

	this.timeline.addTween(cjs.Tween.get(this.lines4).wait(5));

	// Line5
	this.lines5 = new lib.TutorialLines5();
	this.lines5.name = "lines5";
	this.lines5.setTransform(-34.45,-449.4);

	this.timeline.addTween(cjs.Tween.get(this.lines5).wait(5));

	// bg1
	this.bg1 = new lib.TutorialBackgroundBird();
	this.bg1.name = "bg1";
	this.bg1.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg1).wait(5));

	// bg2
	this.bg2 = new lib.TutorialBackground2();
	this.bg2.name = "bg2";
	this.bg2.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg2).wait(5));

	// bg3
	this.bg3 = new lib.TutorialBackgroundNext();
	this.bg3.name = "bg3";
	this.bg3.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg3).wait(5));

	// bg4
	this.bg4 = new lib.TutorialBackground4();
	this.bg4.name = "bg4";
	this.bg4.setTransform(816,1204,1,1,0,0,0,816,1204);
	this.bg4.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg4).wait(5));

	// bg5
	this.bg5 = new lib.TutorialBackgroundPractice();
	this.bg5.name = "bg5";
	this.bg5.setTransform(816,1204,1,1,0,0,0,816,1204);
	this.bg5.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg5).wait(5));

	// bottom
	this.bottom = new lib.EmptyHudBottom();
	this.bottom.name = "bottom";
	this.bottom.setTransform(-8.75,790.45,1,1,0,0,0,750,89.4);

	this.timeline.addTween(cjs.Tween.get(this.bottom).wait(5));

	// game1
	this.game1 = new lib.TutorialGameBackground1();
	this.game1.name = "game1";

	this.timeline.addTween(cjs.Tween.get(this.game1).wait(5));

	// game2
	this.game2 = new lib.TutorialGameBackground2();
	this.game2.name = "game2";

	this.timeline.addTween(cjs.Tween.get(this.game2).wait(5));

	// game3
	this.game3 = new lib.TutorialGameBackground3();
	this.game3.name = "game3";
	this.game3.setTransform(39.25,60);

	this.timeline.addTween(cjs.Tween.get(this.game3).wait(5));

	// game4
	this.game4 = new lib.TutorialGameBackground4();
	this.game4.name = "game4";
	this.game4.setTransform(0,170);

	this.timeline.addTween(cjs.Tween.get(this.game4).wait(5));

	// game5
	this.game5 = new lib.TutorialGameBackground5();
	this.game5.name = "game5";
	this.game5.setTransform(0,50);

	this.timeline.addTween(cjs.Tween.get(this.game5).wait(5));

	// panel bg
	this.instance = new lib.BigPanelBG();
	this.instance.setTransform(-540,-871.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(5));

	// overlay
	this.overlay = new lib.Overlay();
	this.overlay.name = "overlay";
	this.overlay.setTransform(17.95,-4.4,1.0217,1.0186,0,0,0,673.4,1052.5);
	this.overlay.alpha = 0.2813;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-672.8,-1184.2,1752.2,2254.5);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hudBottom
	this.hudBottom = new lib.HudBottom();
	this.hudBottom.name = "hudBottom";
	this.hudBottom.setTransform(-522.75,637.35);

	this.timeline.addTween(cjs.Tween.get(this.hudBottom).wait(1));

	// hud
	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(0,-766.05,1,1,0,0,0,13.9,-0.2);

	this.timeline.addTween(cjs.Tween.get(this.hud).wait(1));

	// level
	this.level = new lib.LevelPlaceholder();
	this.level.name = "level";
	this.level.setTransform(0,-34);

	this.timeline.addTween(cjs.Tween.get(this.level).wait(1));

	// Background
	this.bg = new lib.Backgroundwhite();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-667.5,-1238.3,1746.9,2299.8999999999996), null);


// stage content:
(lib.MainAssets_RTL = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// other elements
	this.instance = new lib.FeedbackPanel();
	this.instance.setTransform(-1372.8,155.25,1,1,0,0,0,-0.5,-0.4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// tutorial
	this.instance_1 = new lib.TutorialOverlaySkin();
	this.instance_1.setTransform(3732.45,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance_1.cache(-675,-1186,1756,2259);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Level assets
	this.instance_2 = new lib.Pond14();
	this.instance_2.setTransform(6116.9,-3052,1,1,0,0,0,3.2,-24.9);

	this.instance_3 = new lib.Pond13();
	this.instance_3.setTransform(4617.3,-3052,1,1,0,0,0,3.2,-24.9);

	this.instance_4 = new lib.Pond12();
	this.instance_4.setTransform(3117.65,-3056.9,1,1,0,0,0,0.1,-29.8);

	this.instance_5 = new lib.Pond11();
	this.instance_5.setTransform(1618.05,-3056.9,1,1,0,0,0,0.1,-29.8);

	this.instance_6 = new lib.Pond10();
	this.instance_6.setTransform(118.45,-3056.9,1,1,0,0,0,0.1,-29.8);

	this.instance_7 = new lib.Pond9();
	this.instance_7.setTransform(-1381.2,-3056.9,1,1,0,0,0,0.1,-29.8);

	this.instance_8 = new lib.Pond8();
	this.instance_8.setTransform(-2880.8,-3056.9,1,1,0,0,0,0.1,-29.8);

	this.instance_9 = new lib.Pond7();
	this.instance_9.setTransform(6119.85,-5208.3,1,1,0,0,0,0.1,-29.8);

	this.instance_10 = new lib.Fish7F();
	this.instance_10.setTransform(2975.5,-971.8,1,1,0,0,0,-0.2,-113.2);

	this.instance_11 = new lib.Fish7E();
	this.instance_11.setTransform(2975.5,-1247.1,1,1,0,0,0,-0.2,-113.2);

	this.instance_12 = new lib.Fish7D();
	this.instance_12.setTransform(2975.5,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_13 = new lib.Fish7C();
	this.instance_13.setTransform(2975.5,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_14 = new lib.Fish7B();
	this.instance_14.setTransform(2975.5,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_15 = new lib.Fish7A();
	this.instance_15.setTransform(2975.5,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_16 = new lib.Pond6();
	this.instance_16.setTransform(5004.2,-4628.8,1,1,0,0,0,384.5,549.5);

	this.instance_17 = new lib.Pond5();
	this.instance_17.setTransform(3504.1,-4628.8,1,1,0,0,0,384.5,549.5);

	this.instance_18 = new lib.Pond4();
	this.instance_18.setTransform(2004,-4628.8,1,1,0,0,0,384.5,549.5);

	this.instance_19 = new lib.Pond3();
	this.instance_19.setTransform(503.9,-4628.8,1,1,0,0,0,384.5,549.5);

	this.instance_20 = new lib.Pond2();
	this.instance_20.setTransform(-996.25,-4628.8,1,1,0,0,0,384.5,549.5);

	this.instance_21 = new lib.Fish6F();
	this.instance_21.setTransform(2729.8,-971.8,1,1,0,0,0,-0.2,-113.2);

	this.instance_22 = new lib.Fish5F();
	this.instance_22.setTransform(2483.4,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_23 = new lib.Fish4F();
	this.instance_23.setTransform(2226.1,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_24 = new lib.Fish3F();
	this.instance_24.setTransform(1958,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_25 = new lib.Fish2F();
	this.instance_25.setTransform(1699.1,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_26 = new lib.Fish1F();
	this.instance_26.setTransform(1450.7,-981.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_27 = new lib.Fish6E();
	this.instance_27.setTransform(2729.8,-1247.1,1,1,0,0,0,-0.2,-113.2);

	this.instance_28 = new lib.Fish6D();
	this.instance_28.setTransform(2729.8,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_29 = new lib.Fish6C();
	this.instance_29.setTransform(2729.8,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_30 = new lib.Fish6B();
	this.instance_30.setTransform(2729.8,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_31 = new lib.Fish6A();
	this.instance_31.setTransform(2729.8,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_32 = new lib.Fish5E();
	this.instance_32.setTransform(2483.4,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_33 = new lib.Fish5D();
	this.instance_33.setTransform(2475.3,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_34 = new lib.Fish5C();
	this.instance_34.setTransform(2475.3,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_35 = new lib.Fish5B();
	this.instance_35.setTransform(2483.4,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_36 = new lib.Fish5A();
	this.instance_36.setTransform(2483.4,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_37 = new lib.Fish4E();
	this.instance_37.setTransform(2226.1,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_38 = new lib.Fish4D();
	this.instance_38.setTransform(2226.1,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_39 = new lib.Fish4C();
	this.instance_39.setTransform(2226.1,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_40 = new lib.Fish4B();
	this.instance_40.setTransform(2226.1,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_41 = new lib.Fish4A();
	this.instance_41.setTransform(2226.1,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_42 = new lib.Fish3E();
	this.instance_42.setTransform(1958,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_43 = new lib.Fish3D();
	this.instance_43.setTransform(1958,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_44 = new lib.Fish3C();
	this.instance_44.setTransform(1958,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_45 = new lib.Fish3A();
	this.instance_45.setTransform(1958,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_46 = new lib.Fish3B();
	this.instance_46.setTransform(1958,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_47 = new lib.Fish2E();
	this.instance_47.setTransform(1699.1,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_48 = new lib.Fish2D();
	this.instance_48.setTransform(1699.1,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_49 = new lib.Fish2C();
	this.instance_49.setTransform(1699.1,-1772.2,1,1,0,0,0,-0.2,-113.2);

	this.instance_50 = new lib.Fish2B();
	this.instance_50.setTransform(1699.1,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_51 = new lib.Fish2A();
	this.instance_51.setTransform(1699.1,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_52 = new lib.Fish1E();
	this.instance_52.setTransform(1450.7,-1257,1,1,0,0,0,-0.2,-113.2);

	this.instance_53 = new lib.Fish1D();
	this.instance_53.setTransform(1450.7,-1521.65,1,1,0,0,0,-0.2,-113.2);

	this.instance_54 = new lib.Fish1C();
	this.instance_54.setTransform(1450.7,-1776.5,1,1,0,0,0,-0.2,-113.2);

	this.instance_55 = new lib.Fish1B();
	this.instance_55.setTransform(1450.7,-2045.7,1,1,0,0,0,-0.2,-113.2);

	this.instance_56 = new lib.Fish1A();
	this.instance_56.setTransform(1450.7,-2317.3,1,1,0,0,0,-0.2,-113.2);

	this.instance_57 = new lib.PuddleButton();
	this.instance_57.setTransform(-441.25,839.55,1,1,0,0,0,57,39);

	this.instance_58 = new lib.Pond1();
	this.instance_58.setTransform(-2496.35,-4628.8,1,1,0,0,0,384.5,549.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_58},{t:this.instance_57},{t:this.instance_56},{t:this.instance_55},{t:this.instance_54},{t:this.instance_53},{t:this.instance_52},{t:this.instance_51},{t:this.instance_50},{t:this.instance_49},{t:this.instance_48},{t:this.instance_47},{t:this.instance_46},{t:this.instance_45},{t:this.instance_44},{t:this.instance_43},{t:this.instance_42},{t:this.instance_41},{t:this.instance_40},{t:this.instance_39},{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	// level prepare
	this.instance_59 = new lib.LevelPrepareOverlaySkin();
	this.instance_59.setTransform(-807.35,424.95,1,1,0,0,0,537.5,733.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_59).wait(1));

	// gatekeeper
	this.instance_60 = new lib.GateKeeperOverlaySkin();
	this.instance_60.setTransform(543.8,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance_60.cache(-722,-1182,1808,2305);

	this.timeline.addTween(cjs.Tween.get(this.instance_60).wait(1));

	// endscreen
	this.instance_61 = new lib.EndScreenSkin();
	this.instance_61.setTransform(2067.75,871);

	this.timeline.addTween(cjs.Tween.get(this.instance_61).wait(1));

	// gamescreen
	this.instance_62 = new lib.GameScreenSkin();
	this.instance_62.setTransform(540,986,1,1,0,0,0,0,115);

	this.timeline.addTween(cjs.Tween.get(this.instance_62).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-3008.4,-5545.8,9801.1,9098.4);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#666666",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets_RTL/BackDisabled.png", id:"MainAssets_RTL_BackDisabled", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackDown.png", id:"MainAssets_RTL_BackDown", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Background_Blue.png", id:"MainAssets_RTL_Background_Blue", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel01s.png", id:"MainAssets_RTL_BackgroundLevel01s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel02s.png", id:"MainAssets_RTL_BackgroundLevel02s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel03s.png", id:"MainAssets_RTL_BackgroundLevel03s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel04s.png", id:"MainAssets_RTL_BackgroundLevel04s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel05s.png", id:"MainAssets_RTL_BackgroundLevel05s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel06s.png", id:"MainAssets_RTL_BackgroundLevel06s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel07s.png", id:"MainAssets_RTL_BackgroundLevel07s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel08s.png", id:"MainAssets_RTL_BackgroundLevel08s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel09s.png", id:"MainAssets_RTL_BackgroundLevel09s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel10s.png", id:"MainAssets_RTL_BackgroundLevel10s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel11s.png", id:"MainAssets_RTL_BackgroundLevel11s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel12s.png", id:"MainAssets_RTL_BackgroundLevel12s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel13s.png", id:"MainAssets_RTL_BackgroundLevel13s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackgroundLevel14s.png", id:"MainAssets_RTL_BackgroundLevel14s", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BackUp.png", id:"MainAssets_RTL_BackUp", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BigPanelBG.png", id:"MainAssets_RTL_BigPanelBG", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BirdSpotterBalloon.png", id:"MainAssets_RTL_BirdSpotterBalloon", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/BottomFloatingPanelBG.png", id:"MainAssets_RTL_BottomFloatingPanelBG", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Buoy.png", id:"MainAssets_RTL_Buoy", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/EndscreenBGPanel.png", id:"MainAssets_RTL_EndscreenBGPanel", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/EndscreenBGPanelLonger.png", id:"MainAssets_RTL_EndscreenBGPanelLonger", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FeedbackPanelBg.png", id:"MainAssets_RTL_FeedbackPanelBg", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish01_1.png", id:"MainAssets_RTL_Fish01_1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish01_2.png", id:"MainAssets_RTL_Fish01_2", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish01_3.png", id:"MainAssets_RTL_Fish01_3", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish01_4.png", id:"MainAssets_RTL_Fish01_4", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish01_5.png", id:"MainAssets_RTL_Fish01_5", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish01_6.png", id:"MainAssets_RTL_Fish01_6", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish01_7.png", id:"MainAssets_RTL_Fish01_7", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish02_1.png", id:"MainAssets_RTL_Fish02_1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish02_2.png", id:"MainAssets_RTL_Fish02_2", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish02_3.png", id:"MainAssets_RTL_Fish02_3", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish02_4.png", id:"MainAssets_RTL_Fish02_4", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish02_5.png", id:"MainAssets_RTL_Fish02_5", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish02_6.png", id:"MainAssets_RTL_Fish02_6", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish02_7.png", id:"MainAssets_RTL_Fish02_7", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish03_1.png", id:"MainAssets_RTL_Fish03_1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish03_2.png", id:"MainAssets_RTL_Fish03_2", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish03_3.png", id:"MainAssets_RTL_Fish03_3", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish03_4.png", id:"MainAssets_RTL_Fish03_4", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish03_5.png", id:"MainAssets_RTL_Fish03_5", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish03_6.png", id:"MainAssets_RTL_Fish03_6", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish03_7.png", id:"MainAssets_RTL_Fish03_7", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish04_1.png", id:"MainAssets_RTL_Fish04_1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish04_2.png", id:"MainAssets_RTL_Fish04_2", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish04_3.png", id:"MainAssets_RTL_Fish04_3", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish04_4.png", id:"MainAssets_RTL_Fish04_4", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish04_5.png", id:"MainAssets_RTL_Fish04_5", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish04_6.png", id:"MainAssets_RTL_Fish04_6", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish04_7.png", id:"MainAssets_RTL_Fish04_7", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish05_1.png", id:"MainAssets_RTL_Fish05_1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish05_2.png", id:"MainAssets_RTL_Fish05_2", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish05_3.png", id:"MainAssets_RTL_Fish05_3", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish05_4.png", id:"MainAssets_RTL_Fish05_4", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish05_5.png", id:"MainAssets_RTL_Fish05_5", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish05_6.png", id:"MainAssets_RTL_Fish05_6", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish05_7.png", id:"MainAssets_RTL_Fish05_7", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish06_1.png", id:"MainAssets_RTL_Fish06_1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish06_2.png", id:"MainAssets_RTL_Fish06_2", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish06_3.png", id:"MainAssets_RTL_Fish06_3", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish06_4.png", id:"MainAssets_RTL_Fish06_4", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish06_5.png", id:"MainAssets_RTL_Fish06_5", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish06_6.png", id:"MainAssets_RTL_Fish06_6", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fish06_7.png", id:"MainAssets_RTL_Fish06_7", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fishingtut1.png", id:"MainAssets_RTL_Fishingtut1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fishingtut2.png", id:"MainAssets_RTL_Fishingtut2", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/fishingtut4.png", id:"MainAssets_RTL_fishingtut4", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fishingtut5.png", id:"MainAssets_RTL_Fishingtut5", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Fishingspot_1.png", id:"MainAssets_RTL_Fishingspot_1", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FishingSpotBubble.png", id:"MainAssets_RTL_FishingSpotBubble", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FishingSpotDarker.png", id:"MainAssets_RTL_FishingSpotDarker", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FishingSpotHighlight.png", id:"MainAssets_RTL_FishingSpotHighlight", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FishingspotPart01.png", id:"MainAssets_RTL_FishingspotPart01", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FishingSpotPart02.png", id:"MainAssets_RTL_FishingSpotPart02", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FishingSpotPart03.png", id:"MainAssets_RTL_FishingSpotPart03", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FishingSpotPart04.png", id:"MainAssets_RTL_FishingSpotPart04", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/FloatingPracticePanelBG.png", id:"MainAssets_RTL_FloatingPracticePanelBG", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/MainButtonDis.png", id:"MainAssets_RTL_MainButtonDis", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/MainButtonDown.png", id:"MainAssets_RTL_MainButtonDown", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/MainButtonHi.png", id:"MainAssets_RTL_MainButtonHi", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/MainButtonUp.png", id:"MainAssets_RTL_MainButtonUp", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/ProfCorrect.png", id:"MainAssets_RTL_ProfCorrect", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/ProfessorRod.png", id:"MainAssets_RTL_ProfessorRod", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/ProfIncorrect.png", id:"MainAssets_RTL_ProfIncorrect", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/ProfNeutral_Closed.png", id:"MainAssets_RTL_ProfNeutral_Closed", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/Splashscreen.png", id:"MainAssets_RTL_Splashscreen", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/SpotterTimerBG.png", id:"MainAssets_RTL_SpotterTimerBG", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/SpotterTimerOutline.png", id:"MainAssets_RTL_SpotterTimerOutline", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/UndoIcon.png", id:"MainAssets_RTL_UndoIcon", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/UndoIconDisabled.png", id:"MainAssets_RTL_UndoIconDisabled", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/UndoIconHi.png", id:"MainAssets_RTL_UndoIconHi", bundle:"MainAssets_RTL"},
		{src:"assets/skins/images/MainAssets_RTL/WhiteArrow.png", id:"MainAssets_RTL_WhiteArrow", bundle:"MainAssets_RTL"}
	],
	preloads: []
};



})(lib.MainAssets_RTL = {}, images, ss, createjs);
module.exports = lib.MainAssets_RTL;